module.exports = __webpack_public_path__ + "static/media/app-store.d45b7b44.png";